module.exports = __webpack_public_path__ + "static/media/in-progress.b8fec710.png";